import { TextareaProps } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import { CmFormControl, CmFormLabel, CmTextarea } from '@/components/uiParts';

interface Props extends TextareaProps {
  fontWeight?: 'normal' | 'bold';
  isRequired?: boolean;
  label: string;
  id?: string;
  error?: ReactNode;
}

export const CmLabelAndTextarea: React.FC<Props> = ({
  fontWeight = 'normal',
  isRequired = false,
  isInvalid = false,
  label,
  id = '',
  borderColor = 'inherit',
  width = 'full',
  children,
  error,
  ...rest
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel htmlFor={id} {...{ isRequired, fontWeight }}>
        {label}
      </CmFormLabel>
      <CmTextarea
        {...{
          isRequired,
          id,
          borderColor,
          ...rest,
        }}
      >
        {children}
      </CmTextarea>
      {error}
    </CmFormControl>
  );
};
